import {PreparedUISampleGroup} from 'workflows/samples/PreparedSampleGroupConstants';

export default function sampleGroupsToContainerIds(
  sampleGroups: Array<PreparedUISampleGroup>
): Array<string> {
  const containerIds = [];
  for (const sampleGroup of sampleGroups) {
    for (const tag of sampleGroup.tags) {
      for (const sample of tag.targetSamples) {
        if (sample.containerId) {
          containerIds.push(sample.containerId);
        }
      }
    }
  }
  return containerIds;
}
